<template>
  <span class="brand-icon">
    <svg :width="size" :height="size" viewBox="0 0 96 96" aria-hidden="true">
      <defs>
        <linearGradient :id="gid" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#5b73c4" />
          <stop offset="1" stop-color="#33489a" />
        </linearGradient>
      </defs>
      <rect x="4" y="4" width="88" height="88" rx="24" :fill="`url(#${gid})`" />
      <!-- highlight superior sutil -->
      <path d="M4 28 Q4 4 28 4 H68 Q92 4 92 28" fill="#fff" fill-opacity="0.1" />
      <!-- glifo: factura + sello de check (DTE validado) -->
      <g transform="translate(24,24)">
        <path d="M12 6 H29 L36 13 V42 H12 Z" fill="#fff" />
        <path d="M29 6 L36 13 L29 13 Z" fill="#33489a" fill-opacity="0.22" />
        <path d="M17 21 H31 M17 27 H30" stroke="#33489a" stroke-width="2.4" stroke-linecap="round" />
        <circle cx="33" cy="35" r="9" fill="#fff" />
        <path
          class="ic-draw"
          d="M28.6 35 L31.8 38.2 L37.4 31.6"
          stroke="#33489a"
          stroke-width="2.8"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </span>
</template>

<script>
// Logo de marca de Facturación (estilo "app-icon" del ecosistema): squircle con
// degradado azul + factura con sello de check. Mismo lenguaje que las tiles del
// portal del Hub y el logo de SmartInventory. El check se redibuja al pasar el
// cursor (clase ic-draw); respeta prefers-reduced-motion.
export default {
  name: 'FacturacionLogo',
  props: {
    size: { type: [Number, String], default: 38 },
  },
  data() {
    return { gid: 'fg-' + Math.random().toString(36).slice(2, 8) }
  },
}
</script>

<style scoped>
.brand-icon {
  display: inline-flex;
  line-height: 0;
}
.brand-icon svg {
  filter: drop-shadow(0 4px 9px rgba(23, 35, 57, 0.18));
}
.ic-draw {
  stroke-dasharray: 26;
}
.brand-icon:hover .ic-draw {
  animation: ic-redraw 0.55s 0.05s ease;
}
@keyframes ic-redraw {
  from {
    stroke-dashoffset: 26;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .brand-icon:hover .ic-draw {
    animation: none;
  }
}
</style>
